var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.listLoading,
          expression: "listLoading",
        },
      ],
      staticStyle: { width: "100%" },
      attrs: {
        id: "order-history-table",
        data: _vm.list,
        border: "",
        fit: "",
        "highlight-current-row": "",
      },
    },
    [
      _c("el-table-column", {
        attrs: {
          width: "150",
          label: "Type",
          sortable: "",
          "sort-method": _vm.sortHistoryType,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [_c("span", [_vm._v(_vm._s(row.historyType))])]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          "min-width": 67,
          label: "Status",
          sortable: "",
          "sort-method": _vm.sortHistoryStatus,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", { staticClass: "wrap-text" }, [
                  _vm._v(" " + _vm._s(row.historyStatus) + " "),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          width: "180px",
          align: "center",
          label: "Date",
          sortable: "",
          "sort-method": _vm.sortStatusDate,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("span", [
                  _vm._v(_vm._s(_vm._f("parseDateTime")(row.statusChangeDate))),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }